import {Component, OnInit} from '@angular/core';
import {
  MatDialog} from '@angular/material/dialog';
import {AppNotification, NotificationService} from '../notification.service';
import {NotificationSendEmailComponent} from "./notification-send-email.component";
import {FeatureFlagsService} from "../../core/feature-flags.service";

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {

  notifications: Array<AppNotification>;

  constructor(private readonly notificationService: NotificationService,
              public readonly featureFlagsService: FeatureFlagsService,
              public dialog: MatDialog) {
  }

  openSendEmailDialog(notification): void {
    console.log(notification);
    const dialogRef = this.dialog.open(NotificationSendEmailComponent, {
      data: {notification: notification},
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ngOnInit() {
    this.notifications = this.notificationService.notifications;
  }

  remove(index) {
    this.notificationService.removeNotification(index);
  }

  notType(notification) {
    let res;
    switch (notification.type) {
      case 'info':
        res = 'notification-info';
        break;
      case 'error':
        res = 'notification-error';
        break;
      case 'warning':
        res = 'notification-warning';
        break;
      case 'success':
        res = 'notification-success';
        break;
      default :
        res = 'notification-info';
        console.warn('Unknown notification type: \'' + notification.type + '\'');
    }
    return res;
  }

}
